import { Component, OnInit, OnDestroy } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { getTitle, getDescription } from '../../lib/helpers';
import { BreadCrumbsService } from '../../breadcrumbs.service';
import { OrderService } from '../order.service';
import { UserService } from '../../user.service';

@Component({
  selector: 'order-success',
  templateUrl: './order-success.component.html'
})
export class OrderSuccessComponent implements OnInit, OnDestroy {
  message: string = '';

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private breadCrumbsService: BreadCrumbsService,
    private orderService: OrderService,
    public userService: UserService,
    private router: Router,
  ) {}

  public ngOnInit() {
    if (!this.orderService.orderSuccessMsg) return this.router.navigate(['/404']);

    this.titleService.setTitle(getTitle('Заказ успешно создан'));
    this.metaService.updateTag({name: 'description', content: getDescription('Заказ успешно создан')});
    this.breadCrumbsService.create([{
      name: 'Заказ успешно создан',
      color: 'general-primary'
    }]);

    this.message = this.orderService.orderSuccessMsg;
  }

  public ngOnDestroy() {
    this.orderService.orderSuccessMsg = '';
  }
}
